module.exports = __webpack_public_path__ + "img/icon-nav8_blue.0461a3ca.svg";